interface CognitoAuthConfig {
  authority: string;
  client_id: string;
  identity_id: string;
  redirect_uri: string;
  response_type: string;
  scope: string;
  cognito_domain: string;
  logout_uri: string;
}

interface StageConfig {
  domainName: string;
  cognitoAuthConfig: CognitoAuthConfig;
  piperBridgeGatewayUrl: string;
}

interface StageConfigs {
  localhost: StageConfig;
  alpha: StageConfig;
  beta: StageConfig;
  production: StageConfig;
}

export const STAGE_CONFIG: StageConfigs = Object.freeze({
  localhost: Object.freeze({
    domainName: "localhost",
    piperBridgeGatewayUrl: "https://aervcgrq67.execute-api.us-west-2.amazonaws.com/prod",
    cognitoAuthConfig: {
      authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_ros4cie9s",
      client_id: "28jn2ruc5p4q1v30aosc8trr1n",
      identity_id: "us-east-1:88774149-72af-4cf2-a57c-dc48ebba92e2",
      redirect_uri: "http://localhost:3000",
      response_type: "code",
      scope: "email openid",
      cognito_domain: "https://us-east-1ros4cie9s.auth.us-east-1.amazoncognito.com",
      logout_uri: "http://localhost:3000"
    }
  }),
  alpha: Object.freeze({
    domainName: "chalwang-designtech.amazon.dev",
    piperBridgeGatewayUrl: "https://aervcgrq67.execute-api.us-west-2.amazonaws.com/prod",
    cognitoAuthConfig: {
      authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_ros4cie9s",
      client_id: "28jn2ruc5p4q1v30aosc8trr1n",
      identity_id: "us-east-1:88774149-72af-4cf2-a57c-dc48ebba92e2",
      redirect_uri: "https://chalwang-designtech.amazon.dev",
      response_type: "code",
      scope: "email openid",
      cognito_domain: "https://us-east-1ros4cie9s.auth.us-east-1.amazoncognito.com",
      logout_uri: "https://chalwang-designtech.amazon.dev"
    },
  }),
  beta: Object.freeze({
    domainName: "workbench.sandbox-designtech.amazon.dev",
    piperBridgeGatewayUrl: "https://aervcgrq67.execute-api.us-west-2.amazonaws.com/prod",
    cognitoAuthConfig: {
      authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_2SfIQFOvN",
      client_id: "3vbe910j1evep3a2svmmihfqk3",
      identity_id: "us-east-1:f7ba04a1-6b61-4c24-8e3b-3e50768563ba",
      redirect_uri: "https://workbench.sandbox-designtech.amazon.dev",
      response_type: "code",
      scope: "email openid",
      cognito_domain: "https://us-east-12sfiqfovn.auth.us-east-1.amazoncognito.com",
      logout_uri: "https://workbench.sandbox-designtech.amazon.dev"
    }
  }),
  production: Object.freeze({
    domainName: "workbench.designtech.amazon.dev",
    piperBridgeGatewayUrl: "https://aervcgrq67.execute-api.us-west-2.amazonaws.com/prod",
    cognitoAuthConfig: {
      authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_1fVVEoQzt",
      client_id: "4a7mbr1t1kos4qsh3cdq3dc6kr",
      identity_id: "us-east-1:bb2e8ec6-bd61-4182-b778-bebf8b6218d2",
      redirect_uri: "https://workbench.designtech.amazon.dev",
      response_type: "code",
      scope: "email openid",
      cognito_domain: "https://us-east-11fVVEoQzt.auth.us-east-1.amazoncognito.com",
      logout_uri: "https://workbench.designtech.amazon.dev"
    }
  })
});

export const stageConfig = (): StageConfig | undefined => {
  const domainName = window.location.hostname;
  console.log(window.location)
  return Object.values(STAGE_CONFIG).find(
    (config) => config.domainName === domainName
  );
};

export const getStageConfig = (): StageConfig => {
  const config = stageConfig();
  console.log(config)
  if (!config) {
    throw new Error(`No configuration found for domain: ${window.location.hostname}`);
  }
  return config;
};
